var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.75 17.5V13.75H15V17.5C15 17.8315 14.8683 18.1495 14.6339 18.3839C14.3995 18.6183 14.0815 18.75 13.75 18.75H3.75C3.41848 18.75 3.10054 18.6183 2.86612 18.3839C2.6317 18.1495 2.5 17.8315 2.5 17.5V2.5C2.5 2.16848 2.6317 1.85054 2.86612 1.61612C3.10054 1.3817 3.41848 1.25 3.75 1.25H10V2.5H3.75V17.5H13.75ZM16.4 1.53708L18.4625 3.59958H18.4563C18.6395 3.78651 18.7421 4.03783 18.7421 4.29958C18.7421 4.56133 18.6395 4.81265 18.4563 4.99958L9.70625 13.7496H6.25V10.2871L15 1.53708C15.1869 1.35385 15.4382 1.25122 15.7 1.25122C15.9618 1.25122 16.2131 1.35385 16.4 1.53708ZM7.5 12.4996H9.1875L15.0938 6.59958L13.4 4.90583L7.5 10.8121V12.4996ZM14.2812 4.02458L15.975 5.71833L17.3938 4.29958L15.7 2.60583L14.2812 4.02458Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClass);
export default __webpack_public_path__ + "static/media/class.ba313c84e2e4caae9a7de75edf5f0533.svg";
export { ForwardRef as ReactComponent };